import styled from 'styled-components';
import { theme } from '../../../../shared/const/theme';
import { Link } from '../../Link';
export const Wrapper = styled.div.withConfig({
    componentId: "sc-3f76ed08-0"
})([
    `display:`,
    `;flex-direction:column;flex-grow:1;max-width:1680px;margin:0 auto;`
], (p)=>p.$showing ? 'flex' : 'none');
export const ItemWrapper = styled.div.withConfig({
    componentId: "sc-3f76ed08-1"
})([
    `display:flex;justify-content:`,
    `;flex-direction:row;gap:16px;flex-wrap:wrap;`
], (p)=>p.$centered ? 'center' : 'flex-start');
const activeItemHeading = `
  padding: 12px 0;
  font-size: 21px;
  font-weight: 500;
  color: ${theme.waffle.colors.text.default};
`;
export const ActiveItemHeading = styled.div.withConfig({
    componentId: "sc-3f76ed08-2"
})([
    ``,
    ``
], activeItemHeading);
export const ActiveItemHeadingLink = styled(Link).withConfig({
    componentId: "sc-3f76ed08-3"
})([
    ``,
    ``
], activeItemHeading); //# sourceMappingURL=SimpleList.styled.js.map
